/**
 * @param {string|string[]} namespace
 * @param {Window|{}} globalObj
 * @return {<T>|undefined}
 */
export function getRegisteredGlobal<T>(
    namespace: string | string[],
    globalObj?: any
): T | undefined {
    const target: unknown = (Array.isArray(namespace)
        ? namespace
        : namespace.split(".")
    ).reduce(
        (prev, curr) =>
            prev === null || prev === undefined ? undefined : prev[curr],
        globalObj || window
    );
    return typeof target === "undefined" ? undefined : (target as T);
}
